<div class="audit__content">
    <div *ngIf="projetAuditListLoading$ | async" class="audit__content__loading">
        <app-loading-spinner></app-loading-spinner>
    </div>
    <div *ngIf="projetAuditList$ | async as projetAuditList" class="audit__content__list">
        <app-projet-audit-list [projetAudit]="projetAuditList"></app-projet-audit-list>
    </div>
</div>
